import CWLoader from 'components/CWLoader'

export const Loader = () => <CWLoader logoSize="4rem" />
